import { render } from "./Header.vue?vue&type=template&id=560ead0e"
const script = {}

import "./Header.vue?vue&type=style&index=0&id=560ead0e&lang=css"

import exportComponent from "C:\\MyTools\\withokx\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__